import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'as0027',
    ecrans: ['00-2']
});
